<template>
    <FormFiles
        :id="id"
        v-model="files"
        :title="title"
        accept="image/*"
        :labels="{
            clickToUpload: $t('shared.uploader.click_to_upload'),
            dragAndDrop: $t('shared.uploader.drag_and_drop'),
            fileInfo: $t('shared.uploader.file_details'),
        }"
        :maxSize="10000"
        :errorMessages="{
            invalidSize: $t('shared.invalid.file_size_over'),
            invalidType: $t('shared.invalid.file_type'),
        }"
        :single-file="true"
        @fileSelected="uploadImg"
        @fileRemoved="removeImg"
    />
</template>

<script>
import { mapActions } from "vuex";
import { FormFiles, makeFileModel } from "@easy/ui/forms";

export default {
    components: {
        FormFiles,
    },
    props: {
        id: String,
        modelValue: String,
        title: String,
    },
    data() {
        return {
            files: [],
        };
    },
    computed: {
        model: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    watch: {
        modelValue: {
            handler(value, oldValue) {
                if (!oldValue && value) {
                    this.files = [
                        makeFileModel({
                            url: value,
                        }),
                    ];
                }
            },
            immediate: true,
        },
    },
    methods: {
        ...mapActions("page", ["uploadImage"]),
        async uploadImg(file) {
            this.model = await this.uploadImage({ file });
        },
        removeImg() {
            this.model = "";
        },
    },
};
</script>
